var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import PlainButton from '../../components/plain-button';

import messages from './messages';

var VersionHistoryLink = function VersionHistoryLink(_ref) {
    var className = _ref.className,
        versionCount = _ref.versionCount,
        onClick = _ref.onClick,
        rest = _objectWithoutProperties(_ref, ['className', 'versionCount', 'onClick']);

    var formattedMessageComponent = React.createElement(FormattedMessage, _extends({}, messages.savedVersions, {
        values: { versionCount: versionCount }
    }));

    // Only render it as a link if there is an onClick
    if (onClick) {
        return React.createElement(
            PlainButton,
            _extends({
                onClick: onClick,
                className: classNames('lnk', className)
            }, rest),
            formattedMessageComponent
        );
    }

    return React.createElement(
        'div',
        { className: className },
        formattedMessageComponent
    );
};

VersionHistoryLink.propTypes = {
    className: PropTypes.string.isRequired,

    /** the number of saved versions that exist for this item, should be 2 or more */
    versionCount: PropTypes.number.isRequired,
    onClick: PropTypes.func
};
VersionHistoryLink.defaultProps = {
    className: ''
};

export default VersionHistoryLink;
import PropTypes from 'prop-types';